const headerHtml = `
<button type="button" class="c-header-switch js-header-switch" aria-expanded="false" aria-controls="header-menu">
  <span class="c-header-switch__label">
    <span class="c-header-switch__open">MENU</span>
    <span class="c-header-switch__close">CLOSE</span>
  </span>
  <i></i>
</button>

<header class="l-header" id="header-menu" hidden>
  <div class="l-header__inner">
    <nav class="l-header__nav" aria-label="メインメニュー">
      <div class="l-header__col">
        <a class="l-header__item" href="/special/thanks/index.html">
          <span class="l-header__label">
            <img class="l-header__en l-header__en--top" src="/special/thanks/assets/image/common/ttl_header_01.svg" alt="top" width="113" height="38">
            <span class="l-header__ja">トップ</span>
          </span>
          <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
        </a>
        <a class="l-header__item" href="/special/thanks/information.html">
          <span class="l-header__label">
            <img class="l-header__en l-header__en--news" src="/special/thanks/assets/image/common/ttl_header_02.svg" alt="news" width="135" height="36">
            <span class="l-header__ja">お知らせ</span>
          </span>
          <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
        </a>
        <a class="l-header__item l-header__item--close" href="/special/thanks/index.html#navi">
          <span class="l-header__label">
            <img class="l-header__en l-header__en--navi" src="/special/thanks/assets/image/common/ttl_header_08.svg" alt="navi" width="135" height="36">
            <span class="l-header__ja">ご案内</span>
          </span>
          <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
        </a>
        <details class="l-header__accordion is-open" open>
          <summary class="l-header__item">
            <span class="l-header__label">
              <img class="l-header__en l-header__en--event" src="/special/thanks/assets/image/common/ttl_header_03.svg" alt="event" width="113" height="24">
              <span class="l-header__ja">イベント</span>
            </span>
            <span class="l-header__toggle" aria-hidden="true"></span>
          </summary>
          <div class="l-header__sub">
            <a class="l-header__subitem" href="/special/thanks/index.html#fureai">
              <span class="l-header__ja">ふれあいイベント</span>
              <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
            </a>
            <a class="l-header__subitem" href="/special/thanks/event/ground.html">
              <span class="l-header__ja">グラウンドメインイベント</span>
              <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
            </a>
            <a class="l-header__subitem" href="/special/thanks/event/autographedbaseball.html">
              <span class="l-header__ja">お楽しみイベント</span>
              <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
            </a>
          </div>
        </details>
      </div>
      <div class="l-header__col">
        <a class="l-header__item" href="/special/thanks/index.html#ticket">
          <span class="l-header__label">
            <img class="l-header__en l-header__en--ticket" src="/special/thanks/assets/image/common/ttl_header_04.svg" alt="ticket" width="182" height="33">
            <span class="l-header__ja">チケット</span>
          </span>
          <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
        </a>
        <a class="l-header__item l-header__item--close" href="/special/thanks/gourmet.html">
          <span class="l-header__label">
            <img class="l-header__en l-header__en--gourmet" src="/special/thanks/assets/image/common/ttl_header_05.svg" alt="gourmet" width="240" height="35">
            <span class="l-header__ja">グルメ</span>
          </span>
          <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
        </a>
        <a class="l-header__item l-header__item--close" href="/special/thanks/goods.html">
          <span class="l-header__label">
            <img class="l-header__en l-header__en--goods" src="/special/thanks/assets/image/common/ttl_header_06.svg" alt="goods" width="175" height="39">
            <span class="l-header__ja">グッズ</span>
          </span>
          <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
        </a>
        <a class="l-header__item l-header__item--plain" href="/special/thanks/index.html#others">
          <span class="l-header__label">
            <img class="l-header__en l-header__en--others" src="/special/thanks/assets/image/common/ttl_header_07.svg" alt="others" width="214" height="39">
            <span class="l-header__ja">そのほかの情報</span>
          </span>
          <img class="l-header__arrow" src="/special/thanks/assets/image/common/ico_header_arrow.svg" alt="" width="36" height="36">
        </a>
        <a class="l-header__official" href="https://www.seibulions.jp/index.html" target="_blank" rel="noopener">
          <img src="/special/thanks/assets/image/common/ph_header_01.webp" alt="埼玉西武ライオンズ オフィシャルサイト" width="895" height="201">
        </a>
        <p class="l-header__copyright"><small>© SEIBU Lions / <br class="u-hidden-min-md">TEZUKA PRODUCTIONS All Rights Reserved.</small></p>
      </div>
    </nav>
  </div>
</header>
`;

const footerTopHtml = `
  <div class="l-footer__top">
    <button type="button" class="l-footer__scrolltop js-scroll-top">
      <img src="/special/thanks/assets/image/common/ph_footer_02.webp" alt="ページトップへ戻る" width="254" height="254">
    </button>
  </div>`;

function footerHtml(hideFooterTop) {
  return `
<footer class="l-footer">
  ${hideFooterTop ? '' : footerTopHtml}
  <div class="l-footer__bottom u-bg-blue">
    <div class="l-footer__inner">
      <a class="l-footer__bnr" href="https://www.seibulions.jp/index.html" target="_blank">
        <img src="/special/thanks/assets/image/common/ph_footer_01.webp" alt="埼玉西武ライオンズ オフィシャルサイト" width="774" height="218">
      </a>
      <div class="l-footer__detail">
        <nav class="l-footer__nav">
          <ul class="l-footer__nav__list">
            <li><a href="/special/thanks/index.html">TOP</a></li>
            <li><a href="/special/thanks/information.html">NEWS</a></li>
            <li><a href="/special/thanks/index.html#navi" class="is-close">NAVI</a></li>
            <li><a href="/special/thanks/index.html#fureai">EVENT</a></li>
            <li><a href="/special/thanks/index.html#ticket">TICKET</a></li>
            <li><a href="/special/thanks/gourmet.html" class="is-close">GOURMET</a></li>
            <li><a href="/special/thanks/goods.html" class="is-close">GOODS</a></li>
            <li><a href="/special/thanks/index.html#others">OTHERS</a></li>
          </ul>
        </nav>
        <p class="l-footer__copyright"><small>© SEIBU Lions / TEZUKA <br class="u-hidden-min-md">PRODUCTIONS All Rights Reserved.</small></p>
      </div>
    </div>
  </div>
  <a class="l-footer-fixcv" href="https://ticket.seibulions.jp/?utm_source=officialsite&utm_medium=fbutton&utm_campaign=261023teticketofficialsitefbutton" target="_blank">
    <div class="l-footer-fixcv__inner">
      <img src="/special/thanks/assets/image/common/btn_cv_02.webp" alt="" aria-hidden="true" class="l-footer-fixcv__circle" width="276" height="276">
      <img src="/special/thanks/assets/image/common/btn_cv_01.webp" alt="チケットを買う" class="l-footer-fixcv__base" width="276" height="276">
    </div>
  </a>
</footer>
`;
}

function refreshScrollTrigger() {
  const run = () => {
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  };

  run();
  requestAnimationFrame(run);
}

function replacePlaceholder(element, html) {
  element.insertAdjacentHTML('beforebegin', html);
  element.remove();
  refreshScrollTrigger();
}

export function mountHeaderFooter() {
  const header = document.getElementById('js-site-header');
  if (header) {
    replacePlaceholder(header, headerHtml);
  }

  const footer = document.getElementById('js-site-footer');
  if (footer) {
    replacePlaceholder(footer, footerHtml(footer.hasAttribute('data-hide-footer-top')));
  }
}
